import React, { Component } from "react";

export default class DataEngImg extends Component {
  render() {
    const { theme, ...svgProps } = this.props;
    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500" {...svgProps}>
    <g id="freepik--background-complete--inject-192">
      <path
        d="M167.42,468c21.59-14.41,26.86-41.67,26.4-66.26-.08-4.1.45-8.42-1.47-12.05s-6.5-6.15-10.25-4.48c-3.1,1.39-4.51,4.91-6.28,7.81a24.25,24.25,0,0,1-9.89,9c-2.67,1.31-6,2.09-8.54.63-3.56-2-3.9-6.9-3.81-11q.24-11.4.49-22.81c.09-4.07.17-8.24-1-12.13s-4-7.53-7.93-8.68-8.81,1-9.7,5c-.38,1.66-.06,3.39-.2,5.08s-1,3.56-2.61,4-3.29-.73-4.51-1.94c-4.2-4.18-7-9.53-9.63-14.85s-5.17-10.75-9-15.3-9.1-8.19-15-8.61-12.27,3.09-13.86,8.8,1.72,11.62,5.35,16.33a91.79,91.79,0,0,0,18.93,18.36c1.28.93,2.68,1.94,3.16,3.45.85,2.74-1.8,5.4-4.54,6.25-3.09,1-6.43.6-9.66.93s-6.74,1.68-8,4.66c-1.76,4.15,1.71,8.57,5.14,11.49a79.22,79.22,0,0,0,23.19,13.67c3,1.15,6.2,2.16,8.62,4.3s3.85,5.84,2.32,8.69-5.34,3.71-8.52,3.08-6-2.38-9-3.55c-5.64-2.2-13-1.93-16.7,2.86-2.44,3.15-2.72,7.59-1.57,11.4s3.55,7.12,6.11,10.17c8.94,10.68,20.46,19.34,33.57,24.05s25.3,6.11,38.46,1.58"
        fill={theme.compImgHighlight}
      />
      <path
        d="M165.73,468.42c-3.47-12.45-13-41.74-18.65-55.52l-4.23-10.19c-1.4-3.34-2.78-6.65-4.34-9.8a181.19,181.19,0,0,0-10-17.63c-3.45-5.46-6.93-10.51-10.22-15.22s-6.46-9-9.51-12.83a145.38,145.38,0,0,0-15.72-17c-2-1.85-3.61-3.24-4.71-4.17l-1.26-1a4.16,4.16,0,0,0-.44-.34s.13.14.4.38l1.22,1.1c1.07,1,2.64,2.37,4.62,4.24a152.85,152.85,0,0,1,15.55,17.05c3,3.82,6.15,8.15,9.43,12.86s6.73,9.77,10.16,15.22A183.86,183.86,0,0,1,138,393.17c1.54,3.15,2.92,6.43,4.31,9.78s2.8,6.75,4.23,10.18c5.66,13.77,15.18,43,18.67,55.45"
        fill={theme.compImgHighlight}
      />
      <path
        d="M138.36,392.85a10.91,10.91,0,0,0,.4-1.74c.23-1.13.5-2.77.82-4.79.64-4.06,1.33-9.69,2.08-15.89s1.53-11.82,2.26-15.85c.35-2,.66-3.64.89-4.76a10.09,10.09,0,0,0,.28-1.77,10.63,10.63,0,0,0-.52,1.71c-.3,1.11-.67,2.73-1.08,4.74-.84,4-1.7,9.64-2.45,15.85s-1.39,11.73-1.89,15.91c-.25,1.94-.46,3.56-.63,4.81A10.46,10.46,0,0,0,138.36,392.85Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M85.37,382.25a2.28,2.28,0,0,0,.54.1l1.58.16c1.36.13,3.33.31,5.76.62,4.86.58,11.55,1.62,18.87,3.09s13.9,3.13,18.61,4.45c2.36.65,4.26,1.22,5.57,1.61l1.52.45a1.75,1.75,0,0,0,.54.12s-.17-.1-.51-.24l-1.47-.55c-1.3-.47-3.18-1.11-5.53-1.81-4.69-1.43-11.26-3.14-18.6-4.63a191.59,191.59,0,0,0-19-2.92c-2.44-.26-4.43-.38-5.8-.43l-1.58,0A2,2,0,0,0,85.37,382.25Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M160.6,451.47a3.3,3.3,0,0,0,.36-.64l.93-1.89c.8-1.64,1.9-4,3.22-7,2.64-6,6-14.34,9.67-23.62s7-17.65,9.51-23.67l3-7.11c.33-.79.61-1.43.82-1.93a3.58,3.58,0,0,0,.25-.69,2.75,2.75,0,0,0-.36.64l-.93,1.89c-.8,1.64-1.9,4-3.22,7-2.64,6-6,14.34-9.68,23.62s-7,17.65-9.5,23.66l-3,7.11-.82,1.94A3.33,3.33,0,0,0,160.6,451.47Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M90.33,428a4.63,4.63,0,0,0,.7.28l2,.69,7.53,2.51c6.36,2.13,15.1,5.18,24.75,8.56s18.43,6.38,24.83,8.4c3.2,1,5.79,1.81,7.59,2.32l2.08.59a3.1,3.1,0,0,0,.74.16,4.09,4.09,0,0,0-.7-.28l-2.05-.7-7.53-2.5c-6.35-2.13-15.1-5.18-24.75-8.57s-18.43-6.37-24.82-8.39c-3.2-1-5.8-1.81-7.6-2.32l-2.08-.59A3.1,3.1,0,0,0,90.33,428Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M382.17,279.4s-10.26-5.28-19.41,18.89-12.11,37.85-12.11,37.85-2.56,5.13-6.2,2.36-9.12-11.17-14.55-8.95c-5.62,2.3-6.82,9-4.66,18.39s6.11,30.16,6.46,32-.42,4.7-3.2,3.21-19.47-16.42-26.08-8.07,3.69,33.55,4.76,36.32.65,4.06-.63,4.92-6.42-4.69-11.34-8.74-11.34-7.89-14.75-2.76-2.52,24.8,19.54,54.47l11.13,13.07,17-2.83c36-8.28,49.46-22.67,50.19-28.79s-6.64-7.36-13-7.47-13.88.79-14.3-.7.09-2.73,2.71-4.15,26.8-13.92,27.18-24.56-22-10.1-25.1-10.77-1.81-3.34-.35-4.52,18-14.44,25.7-20.2,11.16-11.63,8.37-17c-2.69-5.21-12.31-2.38-16.88-2.62s-3.18-5.82-3.18-5.82,6.61-12.34,15.32-36.67-2.83-27-2.83-27"
        fill={theme.compImgHighlight}
      />
      <path
        d="M311.5,468.68c6.47-17.84,15.61-42.41,25.79-69.53s19.36-51.65,25.92-69.46c3.26-8.89,5.9-16.09,7.74-21.09l2.11-5.74c.24-.63.42-1.13.56-1.48s.21-.5.21-.5-.05.17-.16.51l-.51,1.51-2,5.77c-1.75,5-4.34,12.23-7.58,21.15-6.46,17.85-15.6,42.42-25.78,69.52S318.41,451,311.86,468.81"
        fill={theme.compImgHighlight}
      />
      <path
        d="M337,341.45a5.37,5.37,0,0,1,.56,1.11c.33.73.78,1.79,1.32,3.11,1.07,2.65,2.46,6.34,3.92,10.43l3.69,10.51c.46,1.26.84,2.32,1.14,3.17A5.53,5.53,0,0,1,348,371a5,5,0,0,1-.57-1.11c-.33-.73-.77-1.79-1.3-3.12-1.05-2.65-2.39-6.36-3.84-10.46s-2.77-7.68-3.77-10.47l-1.16-3.17A5.78,5.78,0,0,1,337,341.45Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M349.6,371.1c-.06-.14,7.42-3.34,16.7-7.14s16.85-6.79,16.91-6.65-7.42,3.33-16.71,7.14S349.65,371.24,349.6,371.1Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M332.09,412a6.59,6.59,0,0,1,1.25-.19l3.43-.37c2.89-.31,6.88-.76,11.27-1.41s8.34-1.37,11.19-1.92l3.39-.64a6.35,6.35,0,0,1,1.25-.18,5.34,5.34,0,0,1-1.21.38c-.78.21-1.93.49-3.35.81-2.84.64-6.79,1.43-11.19,2.07s-8.41,1.05-11.32,1.27c-1.45.1-2.63.17-3.44.19A5.41,5.41,0,0,1,332.09,412Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M314.79,387.72a4.54,4.54,0,0,1,.77.88l1.95,2.52c1.62,2.14,3.84,5.12,6.26,8.43s4.6,6.33,6.14,8.53c.72,1,1.32,1.91,1.81,2.62a4.82,4.82,0,0,1,.61,1,5.39,5.39,0,0,1-.77-.89l-1.95-2.52c-1.63-2.14-3.84-5.12-6.27-8.43s-4.59-6.33-6.14-8.53l-1.81-2.62A4.83,4.83,0,0,1,314.79,387.72Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M294.74,421.88a8.37,8.37,0,0,1,1,1.14l2.51,3.22c2.1,2.73,5,6.53,8.11,10.75s6,8.05,8,10.84l2.38,3.32a8.06,8.06,0,0,1,.81,1.26,7.62,7.62,0,0,1-1-1.14L314,448.05c-2.1-2.73-5-6.53-8.11-10.74s-6-8.05-8-10.84l-2.38-3.33A8.06,8.06,0,0,1,294.74,421.88Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M317.18,451.53a8.76,8.76,0,0,1,1.58-.29l4.33-.62c3.65-.53,8.69-1.27,14.23-2.25s10.55-2,14.16-2.75l4.27-.89a8.62,8.62,0,0,1,1.59-.27,10.18,10.18,0,0,1-1.54.47c-1,.27-2.44.63-4.24,1.06-3.6.85-8.59,1.93-14.14,2.9s-10.62,1.67-14.28,2.1c-1.84.22-3.33.37-4.36.46A11.23,11.23,0,0,1,317.18,451.53Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M68.37,126.45h0a24.14,24.14,0,0,1-24.14-24.14h0A24.14,24.14,0,0,1,68.37,78.17h0a24.14,24.14,0,0,1,24.14,24.14h0A24.14,24.14,0,0,1,68.37,126.45Z"
        fill={theme.compImgHighlight}
      />
      <rect
        x={57.43}
        y={96.93}
        width={5}
        height={16.14}
        style={{
          fill: "#fff",
        }}
      />
      <path
        d="M59.9,94.82a3,3,0,1,0-2.95-3A3,3,0,0,0,59.9,94.82Z"
        style={{
          fill: "#fff",
        }}
      />
      <path
        d="M70.41,104.6c0-2.27,1-3.62,3-3.62,1.84,0,2.72,1.29,2.72,3.62v8.47h5V102.85c0-4.32-2.45-6.41-5.87-6.41a5.63,5.63,0,0,0-4.86,2.66V96.93H65.62v16.14h4.79Z"
        style={{
          fill: "#fff",
        }}
      />
      <path
        d="M442.66,133.41h0a22.49,22.49,0,0,1-22.49-22.5h0a22.49,22.49,0,0,1,22.49-22.49h0a22.48,22.48,0,0,1,22.49,22.49h0A22.49,22.49,0,0,1,442.66,133.41Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M442.66,97.76a13.15,13.15,0,1,0,13.15,13.15A13.15,13.15,0,0,0,442.66,97.76Zm6,19a.79.79,0,0,1-1.12.26c-3.09-1.91-7-2.3-11.57-1.25a.81.81,0,0,1-.39-1.58c5-1.12,9.33-.66,12.75,1.45A.79.79,0,0,1,448.71,116.77Zm1.58-3.62a1,1,0,0,1-1.38.33A17,17,0,0,0,435.82,112a1,1,0,0,1-.59-1.91,19.27,19.27,0,0,1,14.8,1.77A.94.94,0,0,1,450.29,113.15Zm.13-3.68c-4.21-2.5-11.24-2.76-15.25-1.52a1.22,1.22,0,0,1-1.51-.78,1.24,1.24,0,0,1,.78-1.52c4.67-1.38,12.37-1.11,17.23,1.78a1.27,1.27,0,0,1,.46,1.71A1.38,1.38,0,0,1,450.42,109.47Z"
        style={{
          fill: "#fff",
        }}
      />
      <path
        d="M416.18,234.85h0a22.25,22.25,0,0,1-22.25-22.24h0a22.25,22.25,0,0,1,22.25-22.25h0a22.25,22.25,0,0,1,22.24,22.25h0A22.24,22.24,0,0,1,416.18,234.85Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M412.86,220a4.25,4.25,0,0,0,2.86-2,4.56,4.56,0,0,0,.69-2.48,4.12,4.12,0,0,0-.6-2.28,3.51,3.51,0,0,0-1.8-1.38,3.73,3.73,0,0,0,1.19-.89,3.45,3.45,0,0,0,.72-2.29,4,4,0,0,0-.72-2.38,4.81,4.81,0,0,0-4-1.66h-7.52V220.2h7A10.91,10.91,0,0,0,412.86,220Zm-6.12-12.66h3.39a5.91,5.91,0,0,1,1.84.24,1.39,1.39,0,0,1,.84,1.44,1.48,1.48,0,0,1-.63,1.37,3.13,3.13,0,0,1-1.65.38h-3.79Zm0,10.17v-4.16h3.84a3.92,3.92,0,0,1,1.55.27,1.68,1.68,0,0,1,1,1.67,2,2,0,0,1-1,1.94,3.68,3.68,0,0,1-1.57.28Z"
        style={{
          fill: "#fff",
        }}
      />
      <path
        d="M419.05,219.17a6.26,6.26,0,0,0,4.06,1.42,5.58,5.58,0,0,0,4.33-1.68,3.71,3.71,0,0,0,1.12-2.08h-3.08a2.42,2.42,0,0,1-.62.79,2.55,2.55,0,0,1-1.67.53,3,3,0,0,1-1.66-.43,2.75,2.75,0,0,1-1.2-2.43h8.39a15.51,15.51,0,0,0-.1-2.29,5.68,5.68,0,0,0-.92-2.38,4.58,4.58,0,0,0-2-1.7,6.59,6.59,0,0,0-2.71-.54,5.57,5.57,0,0,0-4.12,1.59,6.25,6.25,0,0,0-1.59,4.59Q417.29,217.76,419.05,219.17Zm2.15-7.65a2.4,2.4,0,0,1,1.8-.66,2.67,2.67,0,0,1,1.79.62,2.52,2.52,0,0,1,.8,1.82H420.4A3.16,3.16,0,0,1,421.2,211.52Z"
        style={{
          fill: "#fff",
        }}
      />
      <rect
        x={419.42}
        y={205.52}
        width={6.77}
        height={1.57}
        style={{
          fill: "#fff",
        }}
      />
      <path
        d="M122.62,244h0a17.93,17.93,0,0,1-17.93-17.93h0a17.93,17.93,0,0,1,17.93-17.93h0a17.93,17.93,0,0,1,17.93,17.93h0A17.93,17.93,0,0,1,122.62,244Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M122.62,214.67a11.43,11.43,0,1,0,11.43,11.43A11.43,11.43,0,0,0,122.62,214.67Zm0,2a9.41,9.41,0,0,1,5.76,2,11.69,11.69,0,0,1-4.75,3.51A44.53,44.53,0,0,0,120.3,217,9.34,9.34,0,0,1,122.62,216.66Zm-4.26,1a43,43,0,0,1,3.37,5.12,30.69,30.69,0,0,1-8.28,1.06A9.46,9.46,0,0,1,118.36,217.69Zm-5.18,8.41c0-.08,0-.16,0-.24a32.25,32.25,0,0,0,9.48-1.26c.22.45.43.91.63,1.36a14.75,14.75,0,0,0-7.94,6.18A9.42,9.42,0,0,1,113.18,226.1Zm9.44,9.45a9.42,9.42,0,0,1-5.8-2,12.83,12.83,0,0,1,7.24-5.74,38.2,38.2,0,0,1,2,7.11A9.59,9.59,0,0,1,122.62,235.55Zm5.24-1.6a39.54,39.54,0,0,0-1.83-6.57,18.94,18.94,0,0,1,5.91.19A9.47,9.47,0,0,1,127.86,234Zm-2.59-8.45c-.23-.54-.47-1.07-.73-1.6a13.42,13.42,0,0,0,5.28-3.89,9.32,9.32,0,0,1,2.21,5.56A20.52,20.52,0,0,0,125.27,225.5Z"
        style={{
          fill: "#fff",
        }}
      />
      <polygon
        points="86.65 158.85 90.43 165.75 97.33 169.53 90.43 173.31 86.65 180.21 82.87 173.31 75.97 169.53 82.87 165.75 86.65 158.85"
        fill={theme.compImgHighlight}
      />
      <polygon
        points="365.08 202.28 367.91 207.46 373.09 210.29 367.91 213.13 365.08 218.31 362.24 213.13 357.06 210.29 362.24 207.46 365.08 202.28"
        fill={theme.compImgHighlight}
      />
      <polygon
        points="385.57 38.63 387.46 42.08 390.91 43.97 387.46 45.86 385.57 49.31 383.69 45.86 380.23 43.97 383.69 42.08 385.57 38.63"
        fill={theme.compImgHighlight}
      />
      <polygon
        points="165.73 229.96 167.01 232.29 169.34 233.57 167.01 234.85 165.73 237.19 164.45 234.85 162.12 233.57 164.45 232.29 165.73 229.96"
        fill={theme.compImgHighlight}
      />
      <polygon
        points="399.52 159.35 400.8 161.69 403.13 162.97 400.8 164.24 399.52 166.58 398.24 164.24 395.9 162.97 398.24 161.69 399.52 159.35"
        fill={theme.compImgHighlight}
      />
      <polygon
        points="128.18 82 129.46 84.33 131.79 85.61 129.46 86.89 128.18 89.23 126.9 86.89 124.56 85.61 126.9 84.33 128.18 82"
        fill={theme.compImgHighlight}
      />
      <polygon
        points="405.27 60.7 407.94 65.57 412.82 68.24 407.94 70.91 405.27 75.79 402.6 70.91 397.73 68.24 402.6 65.57 405.27 60.7"
        fill={theme.compImgHighlight}
      />
    </g>
    <g id="freepik--Floor--inject-192">
      <path
        d="M441,469.25c0,.14-85.53.26-191,.26s-191-.12-191-.26,85.51-.26,191-.26S441,469.1,441,469.25Z"
        fill={theme.text}
      />
    </g>
    <g id="freepik--Plants--inject-192">
      <path
        d="M122.47,425.38c2.07,2.89,6,1.89,7.83.1s2.57-4.37,3.25-6.83c1.56-5.62,3.13-11.52,1.88-17.21a9.63,9.63,0,0,0-2.24-4.66,5,5,0,0,0-4.75-1.52c-2,.54-3.21,2.51-4.09,4.38a41.12,41.12,0,0,0-3.88,17.62c0,2.83.38,5.8,2,8.12"
        fill={theme.imageHighlight}
      />
      <path
        d="M130.24,440a17.63,17.63,0,0,1,10.94-1.44,9.12,9.12,0,0,1,5.43,2.36c1.36,1.48,1.64,4.1.1,5.4a5.19,5.19,0,0,1-3.4.9c-2.89,0-6.11-.49-8.4,1.28-1.31,1-2.17,2.66-3.74,3.16a3.72,3.72,0,0,1-4.12-1.78,6.37,6.37,0,0,1-.51-4.7A7.18,7.18,0,0,1,130.24,440Z"
        fill={theme.imageHighlight}
      />
      <path
        d="M116.92,429.61a10.58,10.58,0,0,0,1.56-9.75,18.83,18.83,0,0,0-5.85-8.31,30.87,30.87,0,0,0-10.39-6,11.07,11.07,0,0,0-4.65-.75,4.88,4.88,0,0,0-3.87,2.4c-1.07,2.08,0,4.59,1.14,6.63a79.25,79.25,0,0,0,6.89,10.26c2,2.6,4.41,5.16,7.52,6.32s6.32,1,8-1.18"
        fill={theme.imageHighlight}
      />
      <path
        d="M122.76,469.25a6.67,6.67,0,0,0,.17-1.33c.08-1,.19-2.17.32-3.61A49.4,49.4,0,0,1,124,459a39.72,39.72,0,0,1,1.86-6.26,23,23,0,0,1,3.13-5.68,11.86,11.86,0,0,1,4-3.39,11.31,11.31,0,0,1,3.38-1.09,7,7,0,0,0,1.32-.2,6,6,0,0,0-1.34,0,10.09,10.09,0,0,0-3.53.95,11.9,11.9,0,0,0-4.22,3.42,22.77,22.77,0,0,0-3.25,5.8,38.61,38.61,0,0,0-1.85,6.36,45.77,45.77,0,0,0-.65,5.36c-.1,1.53-.13,2.78-.14,3.63A6.18,6.18,0,0,0,122.76,469.25Z"
        fill={theme.text}
      />
      <path
        d="M123,466.47a2.4,2.4,0,0,0,0-.61c0-.46,0-1,0-1.76,0-1.52,0-3.72,0-6.44.09-5.44.48-13,1.31-21.21s2-15.69,3-21c.25-1.34.5-2.54.74-3.6s.41-2,.6-2.7.29-1.26.39-1.71a3.21,3.21,0,0,0,.11-.61,2.79,2.79,0,0,0-.21.58l-.49,1.69c-.22.73-.45,1.63-.7,2.68s-.54,2.26-.81,3.59a200.18,200.18,0,0,0-3.19,21.06c-.82,8.27-1.16,15.81-1.14,21.26,0,2.72.07,4.93.16,6.45,0,.71.09,1.29.12,1.75A2.3,2.3,0,0,0,123,466.47Z"
        fill={theme.text}
      />
      <path
        d="M122.88,452a14.12,14.12,0,0,0,0-1.83c-.08-1.18-.26-2.88-.61-5a64.63,64.63,0,0,0-1.69-7.21,62.65,62.65,0,0,0-3.1-8.52,45.61,45.61,0,0,0-9-13.74,22,22,0,0,0-2.11-1.92c-.32-.27-.61-.54-.9-.75l-.81-.55a12.1,12.1,0,0,0-1.55-1,55.12,55.12,0,0,1,5.09,4.46A47.81,47.81,0,0,1,117,429.65a67.29,67.29,0,0,1,3.12,8.44c.82,2.65,1.37,5.09,1.79,7.14s.63,3.74.78,4.91A11.49,11.49,0,0,0,122.88,452Z"
        fill={theme.text}
      />
      <path
        d="M379,411.75a11,11,0,0,1,4.23,7.54,19.66,19.66,0,0,1-1.1,8.75c-1.83,5.43-6.21,10.38-10.58,14.1-3.81-5.11-3.35-12.48-2.88-16.21.73-5.89,5.65-16.09,10.33-14.18"
        fill={theme.compImgHighlight}
      />
      <path
        d="M375.31,453.16a9.42,9.42,0,0,1,4.26-8.44,12.5,12.5,0,0,1,9.54-1.57,5.25,5.25,0,0,1,3.76,2.36,4,4,0,0,1-.51,4.05,8.05,8.05,0,0,1-3.41,2.53c-4.48,2-9.18,3.13-13.64,1.07"
        fill={theme.compImgHighlight}
      />
      <path
        d="M365.58,468.28a4.25,4.25,0,0,1,.39-1.14c.29-.72.73-1.75,1.32-3a40.48,40.48,0,0,1,5.67-9.23,20.3,20.3,0,0,1,8.87-6.17,13.15,13.15,0,0,1,3.24-.65,3.58,3.58,0,0,1,1.21,0,27.41,27.41,0,0,0-4.3,1,21.26,21.26,0,0,0-8.53,6.16,47.29,47.29,0,0,0-5.76,9A36.42,36.42,0,0,1,365.58,468.28Z"
        fill={theme.text}
      />
      <path
        d="M376.15,420a12.12,12.12,0,0,1-.23,2c-.19,1.27-.49,3.09-.89,5.34-.8,4.5-2,10.7-3.5,17.51s-3,13-4.16,17.37c-.58,2.21-1.07,4-1.43,5.22a12.84,12.84,0,0,1-.62,1.89,11.9,11.9,0,0,1,.37-2c.32-1.35.74-3.12,1.24-5.26,1.05-4.45,2.48-10.59,4-17.4s2.76-13,3.67-17.45c.44-2.15.81-3.94,1.09-5.3A11.21,11.21,0,0,1,376.15,420Z"
        fill={theme.text}
      />
      <path
        d="M366,454.29a22,22,0,0,0-8-18.49c-1.38-1.12-3.3-2.09-4.86-1.24s-1.77,3-1.52,4.78a18.83,18.83,0,0,0,14.14,15.38"
        fill={theme.compImgHighlight}
      />
      <path
        d="M357.35,441.13a4.58,4.58,0,0,1,.95.65,9.56,9.56,0,0,1,1,.87,14.93,14.93,0,0,1,1.27,1.26,23.12,23.12,0,0,1,2.81,3.75,26.75,26.75,0,0,1,2.38,5.22,27.16,27.16,0,0,1,1.11,5.63,22.66,22.66,0,0,1-.11,4.67,14.09,14.09,0,0,1-.3,1.77,8.72,8.72,0,0,1-.33,1.32,4.21,4.21,0,0,1-.4,1.08c-.13,0,.36-1.61.58-4.21a27.1,27.1,0,0,0,0-4.58,28.76,28.76,0,0,0-1.14-5.49,28.31,28.31,0,0,0-2.27-5.11,25.61,25.61,0,0,0-2.64-3.74C358.57,442.23,357.27,441.23,357.35,441.13Z"
        fill={theme.text}
      />
    </g>
    <g id="freepik--social-idea--inject-192">
      <path
        d="M314.08,241.43c-1.18-3.52-6.36-4.87-9.11-2.36l-1.09,1.38c-1.83,3.24.64,8,4.34,8.35S315.26,245,314.08,241.43Z"
        fill={theme.imageHighlight}
      />
      <g
        style={{
          opacity: 0.7000000000000001,
        }}
      >
        <path
          d="M314.44,241.31c-1.26-3.77-6.79-5.21-9.73-2.53l-1.17,1.48c-2,3.46.69,8.53,4.64,8.91S315.7,245.08,314.44,241.31Z"
          style={{
            fill: "#fff",
          }}
        />
      </g>
      <path
        d="M334.86,213.85c-2-6.06-10.95-8.38-15.67-4.06l-1.88,2.37c-3.15,5.57,1.1,13.74,7.47,14.35S336.88,219.92,334.86,213.85Z"
        fill={theme.imageHighlight}
      />
      <g
        style={{
          opacity: 0.7000000000000001,
        }}
      >
        <path
          d="M335.11,213.77c-2.09-6.22-11.25-8.59-16.1-4.16L317.07,212c-3.23,5.71,1.14,14.08,7.68,14.71S337.19,220,335.11,213.77Z"
          style={{
            fill: "#fff",
          }}
        />
      </g>
      <path
        d="M285.07,22.74c-18-9.48-44.37-.21-55.36,19.24a51.58,51.58,0,0,0-71.88,50c-21.23,8-37.06,28.74-39.21,51.33s9.5,45.92,28.84,57.79,45.41,11.68,64.58-.46c6.71,20.9,31.57,32.67,53.09,28.29s38.7-22.1,46.68-42.56c19.17,10.53,45.66,2.5,57.45-15.93s8.86-44.35-5.2-61.12c-2.27-2.7-4.87-5.34-5.77-8.75-1.09-4.12.53-8.39,1.66-12.5,5.47-19.88-1.38-42.62-16.92-56.17s-39-17.24-58-9.12"
        fill={theme.imageHighlight}
      />
      <g
        style={{
          opacity: 0.7000000000000001,
        }}
      >
        <path
          d="M285.06,22.34c-18.25-9.56-44.5-1-55.64,18.65-16.21-6.93-36.42-4.2-50.91,5.83a52.93,52.93,0,0,0-22.36,45.31c-21.5,8.07-37.55,29-39.72,51.75s9.62,46.32,29.21,58.28,46,11.78,65.43-.46c6.8,21.09,32,33,53.78,28.53s39.21-22.28,47.29-42.92c19.43,10.62,46.27,2.53,58.21-16.06s9-44.73-5.27-61.64c-2.3-2.72-4.94-5.39-5.85-8.83-1.1-4.15.54-8.46,1.69-12.6,5.54-20.05-1.4-43-17.15-56.65s-39.51-17.39-58.71-9.19"
          style={{
            fill: "#fff",
          }}
        />
      </g>
      <path
        d="M295.52,124.18a42.39,42.39,0,1,0-60.45,38.35v10.69h37.16s.22-6,.3-11.36A42.37,42.37,0,0,0,295.52,124.18Z"
        fill={theme.imageHighlight}
      />
      <path
        d="M258.79,173.05s0-.18,0-.53.1-.87.18-1.53c.16-1.34.4-3.32.77-5.86s.88-5.65,1.69-9.22a62.11,62.11,0,0,1,3.85-11.79,40.28,40.28,0,0,1,3.48-6.35,7.85,7.85,0,0,1,2.9-2.6,4.36,4.36,0,0,1,4,.13,2.9,2.9,0,0,1,1.35,1.68,3,3,0,0,1-.18,2.18,6.09,6.09,0,0,1-3.27,2.82,11.6,11.6,0,0,1-8.82-.63,11.72,11.72,0,0,1-6-7.07,8.81,8.81,0,0,1-.25-4.89,3.81,3.81,0,0,1,3.85-2.94,2.72,2.72,0,0,1,2.16,1.49,3.88,3.88,0,0,1,.34,2.61,8.34,8.34,0,0,1-3,4.22,12.66,12.66,0,0,1-9.88,2.86,11,11,0,0,1-8.2-6.11,6.41,6.41,0,0,1-.29-5.13,3.28,3.28,0,0,1,1.86-1.88,3.21,3.21,0,0,1,2.61.24,4.23,4.23,0,0,1,1.79,1.86,6.66,6.66,0,0,1,.65,2.45,12.14,12.14,0,0,1-.65,4.84,12.59,12.59,0,0,1-6,7.11,12.85,12.85,0,0,1-8.77,1.2,6.71,6.71,0,0,1-3.82-2,3.27,3.27,0,0,1-.23-4.08,2.71,2.71,0,0,1,1.9-.93,4,4,0,0,1,2,.39,6.15,6.15,0,0,1,2.6,2.91c1.06,2.3,1.92,4.53,2.78,6.66,3.39,8.55,5.8,15.59,7.41,20.46.8,2.44,1.4,4.35,1.8,5.64.19.63.33,1.12.44,1.47s.13.51.13.51-.07-.16-.18-.49l-.49-1.46c-.44-1.3-1.08-3.18-1.89-5.6-1.67-4.86-4.13-11.87-7.56-20.39-.87-2.12-1.75-4.38-2.8-6.62a5.71,5.71,0,0,0-2.42-2.71,2.54,2.54,0,0,0-3.17,4,6.37,6.37,0,0,0,3.58,1.86,12.32,12.32,0,0,0,8.44-1.19,12.1,12.1,0,0,0,5.73-6.84,11.57,11.57,0,0,0,.61-4.64,4.61,4.61,0,0,0-2.17-3.9,2.68,2.68,0,0,0-2.19-.21,2.74,2.74,0,0,0-1.56,1.6,5.9,5.9,0,0,0,.28,4.72,10.53,10.53,0,0,0,7.81,5.81,12.16,12.16,0,0,0,9.47-2.75,7.82,7.82,0,0,0,2.8-3.93,3.27,3.27,0,0,0-.29-2.26,2.22,2.22,0,0,0-1.75-1.23,3,3,0,0,0-2.11.68,3.66,3.66,0,0,0-1.21,1.9,8.38,8.38,0,0,0,.24,4.6,11.26,11.26,0,0,0,5.73,6.79,11.13,11.13,0,0,0,8.43.63,5.64,5.64,0,0,0,3-2.58,2.52,2.52,0,0,0-1-3.3,4,4,0,0,0-3.62-.12,7.4,7.4,0,0,0-2.75,2.46,39.81,39.81,0,0,0-3.48,6.26,63.4,63.4,0,0,0-3.9,11.71c-.83,3.55-1.36,6.64-1.77,9.18s-.67,4.49-.87,5.85c-.1.65-.17,1.16-.22,1.52S258.79,173.05,258.79,173.05Z"
        fill={theme.text}
      />
      <rect
        x={235.07}
        y={175.31}
        width={36.69}
        height={4.79}
        rx={1.97}
        fill={theme.text}
      />
      <path
        d="M269.37,182.19h-31.9a2.4,2.4,0,1,0,0,4.79H241l4.65,8.84a3.06,3.06,0,0,0,2.72,1.64h11.4a3.05,3.05,0,0,0,2.73-1.67L267,187h2.38a2.4,2.4,0,0,0,0-4.79Z"
        fill={theme.text}
      />
      <g
        style={{
          opacity: 0.2,
        }}
      >
        <path
          d="M243.52,90c.18.77-3,1.91-7.36,4.81A34.83,34.83,0,0,0,220.27,129c.59,5.17,1.79,8.36,1.08,8.72-.3.15-1-.44-1.92-1.77a22.66,22.66,0,0,1-2.77-6.22,31.28,31.28,0,0,1-1.17-10.13A32.22,32.22,0,0,1,225.9,97.17a31.14,31.14,0,0,1,8.49-5.64,22.2,22.2,0,0,1,6.54-1.9C242.53,89.46,243.44,89.62,243.52,90Z"
          style={{
            fill: "#fff",
          }}
        />
      </g>
      <g
        style={{
          opacity: 0.2,
        }}
      >
        <path
          d="M259.07,89.65c-.29,1.42-2.67,2.13-5.36,2.13s-5.05-.76-5.33-2.18c-.12-.71.38-1.46,1.35-2a7.94,7.94,0,0,1,4-1,7.83,7.83,0,0,1,4,1C258.7,88.19,259.19,89,259.07,89.65Z"
          style={{
            fill: "#fff",
          }}
        />
      </g>
      <path
        d="M261.88,196.55c0,.08-.84-.29-2.19-.68a18.11,18.11,0,0,0-5.41-.68,18.65,18.65,0,0,0-5.37,1,19.25,19.25,0,0,1-2.15.8,7,7,0,0,1,2-1.14,15.54,15.54,0,0,1,11-.32A6.53,6.53,0,0,1,261.88,196.55Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M267.05,187.09c0,.14-5.76.26-12.87.26s-12.88-.12-12.88-.26,5.76-.26,12.88-.26S267.05,186.94,267.05,187.09Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M265.06,190.87a17.86,17.86,0,0,1-3.14.32c-1.95.12-4.64.23-7.61.28s-5.67,0-7.61-.07a17.26,17.26,0,0,1-3.15-.23,20,20,0,0,1,3.15-.13l7.6-.1,7.6-.12A20.13,20.13,0,0,1,265.06,190.87Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M299.18,92h0a14.09,14.09,0,0,1-14.1-14.09h0a14.1,14.1,0,0,1,14.1-14.1h0a14.09,14.09,0,0,1,14.09,14.1h0A14.09,14.09,0,0,1,299.18,92Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M306.9,77.49a7.59,7.59,0,0,0-15.17-.14v.33a7.48,7.48,0,0,0,1.08,3.89l-1.36,4,4.2-1.33a7.69,7.69,0,0,0,3.67.93,7.56,7.56,0,0,0,7.59-7.53A1.21,1.21,0,0,0,306.9,77.49ZM299.32,84A6.31,6.31,0,0,1,295.81,83l-2.46.79.8-2.36a6.27,6.27,0,0,1-1.22-3.71c0-.21,0-.41,0-.62a6.38,6.38,0,0,1,12.71.13c0,.16,0,.32,0,.49A6.36,6.36,0,0,1,299.32,84Z"
        style={{
          fill: "#fff",
          fillRule: "evenodd",
        }}
      />
      <path
        d="M302.8,79.2c-.19-.09-1.11-.54-1.28-.6s-.29-.09-.42.09a7.87,7.87,0,0,1-.59.72c-.11.13-.21.14-.4,0a4.89,4.89,0,0,1-1.5-.92,5.55,5.55,0,0,1-1-1.27c-.11-.19,0-.29.08-.38s.19-.22.28-.32l.07-.09.12-.22a.35.35,0,0,0,0-.33l-.57-1.37c-.16-.37-.31-.3-.42-.3l-.36,0a.73.73,0,0,0-.5.23,2.07,2.07,0,0,0-.65,1.54,2.19,2.19,0,0,0,.1.63,4.26,4.26,0,0,0,.66,1.28,7.7,7.7,0,0,0,3.18,2.79c1.9.74,1.9.49,2.24.46a1.83,1.83,0,0,0,1.25-.88,1.47,1.47,0,0,0,.11-.88C303.11,79.34,303,79.29,302.8,79.2Z"
        style={{
          fill: "#fff",
          fillRule: "evenodd",
        }}
      />
      <path
        d="M211.39,134.32l-.82.36-2.4,1c-2.11.89-5.22,2.23-9.17,4.05s-8.76,4.13-14.21,7.06A132.62,132.62,0,0,0,167,158a41.86,41.86,0,0,0-4.46,3.92,19.13,19.13,0,0,0-2,2.34A7.47,7.47,0,0,0,159.3,167a3.65,3.65,0,0,0,.72,2.88,7.63,7.63,0,0,0,2.44,2,22.62,22.62,0,0,0,6.33,2.07A75.2,75.2,0,0,0,182.88,175c4.86,0,9.88-.31,15-.78,20.49-1.91,42.76-6.34,65.7-12.45s44.44-13.5,63.14-22.11c4.66-2.17,9.14-4.44,13.36-6.87a72,72,0,0,0,11.62-8,20,20,0,0,0,4.3-5.06,6.63,6.63,0,0,0,.86-3,4,4,0,0,0-1.15-2.75,11.7,11.7,0,0,0-5.45-2.65,40.72,40.72,0,0,0-5.86-1,98,98,0,0,0-11.08-.35c-3.51.06-6.81.24-9.89.46-6.17.45-11.46,1-15.78,1.59s-7.67,1-9.94,1.35l-2.58.38-.88.11.87-.17,2.58-.42c2.26-.37,5.6-.88,9.92-1.45s9.62-1.2,15.79-1.68c3.08-.23,6.39-.43,9.9-.5a96.2,96.2,0,0,1,11.12.32,40.28,40.28,0,0,1,5.92,1,12.15,12.15,0,0,1,5.65,2.75,4.33,4.33,0,0,1,1.27,3,6.76,6.76,0,0,1-.91,3.22,20,20,0,0,1-4.37,5.19,72.47,72.47,0,0,1-11.68,8.11c-4.23,2.44-8.72,4.72-13.39,6.9-18.72,8.66-40.24,16-63.2,22.18s-45.27,10.54-65.8,12.43c-5.13.46-10.16.74-15,.76a75.48,75.48,0,0,1-14.18-1.09,22.28,22.28,0,0,1-6.44-2.13,7.81,7.81,0,0,1-2.57-2.14,5.43,5.43,0,0,1-.74-1.51c0-.28-.09-.57-.12-.85s0-.56.08-.83a7.81,7.81,0,0,1,1.37-2.91,20.32,20.32,0,0,1,2-2.39,42.6,42.6,0,0,1,4.52-4,131.19,131.19,0,0,1,17.85-11.11c5.46-2.91,10.28-5.19,14.25-7s7.09-3.1,9.22-4l2.42-1C211.1,134.42,211.39,134.32,211.39,134.32Z"
        fill={theme.text}
      />
      <path
        d="M233.42,85.88s-.23,0-.69,0l-2,0L223,85.77c-6.68-.08-16.41-.51-28.3.83a69.57,69.57,0,0,0-9.22,1.66,28.24,28.24,0,0,0-4.67,1.65,11.6,11.6,0,0,0-2.15,1.32,4.63,4.63,0,0,0-1.52,1.94,3.26,3.26,0,0,0,.13,2.43,7.6,7.6,0,0,0,1.51,2.13,22.43,22.43,0,0,0,4.4,3.24,69.12,69.12,0,0,0,10.48,4.78,191.91,191.91,0,0,0,23.83,6.86c8.39,1.9,17.17,3.49,26.21,4.78A312.44,312.44,0,0,0,295,120.81c7.89-.25,15.45-.82,22.23-2.64a22.62,22.62,0,0,0,4.77-1.86,9.28,9.28,0,0,0,2-1.44,4,4,0,0,0,1.09-2,3.32,3.32,0,0,0-.57-2.17A9.76,9.76,0,0,0,323,108.9a23.49,23.49,0,0,0-3.68-2.68,84.71,84.71,0,0,0-14.71-6.56c-4.48-1.59-8.4-2.76-11.62-3.68s-5.74-1.56-7.45-2l-1.94-.5-.66-.18.67.13,2,.44c1.72.41,4.24,1,7.47,1.91s7.17,2,11.67,3.6a83.92,83.92,0,0,1,14.8,6.51,22.89,22.89,0,0,1,3.75,2.72,10,10,0,0,1,1.58,1.83,3.75,3.75,0,0,1,.64,2.43,4.54,4.54,0,0,1-1.19,2.27,9.33,9.33,0,0,1-2.08,1.52,23,23,0,0,1-4.87,1.92c-6.84,1.86-14.41,2.43-22.32,2.7a310.86,310.86,0,0,1-51.4-3.38c-9-1.3-17.85-2.89-26.26-4.81a188.61,188.61,0,0,1-23.88-6.91A70.32,70.32,0,0,1,183,101.37,23.14,23.14,0,0,1,178.47,98a8,8,0,0,1-1.59-2.27,3.64,3.64,0,0,1-.14-2.75,5.16,5.16,0,0,1,1.66-2.13,12,12,0,0,1,2.24-1.35,28,28,0,0,1,4.75-1.67,69.28,69.28,0,0,1,9.27-1.63A197.19,197.19,0,0,1,223,85.57l7.71.21,2,.06Z"
        fill={theme.text}
      />
      <path
        d="M156.46,190.24h0a19.14,19.14,0,0,1-10.48-25h0a19.15,19.15,0,0,1,25-10.48h0a19.16,19.16,0,0,1,10.48,25h0A19.15,19.15,0,0,1,156.46,190.24Z"
        fill={theme.imageHighlight}
      />
      <path
        d="M157.64,177.33a4.22,4.22,0,0,0,1.8,0,4.05,4.05,0,0,0,1.42-.61,4.23,4.23,0,0,0,1.57-1.84,3.91,3.91,0,0,0,.39-2.17,3.3,3.3,0,0,0-1-1.88,3.67,3.67,0,0,0,1.36-.28,3.3,3.3,0,0,0,1.52-1.67,3.76,3.76,0,0,0,.33-2.3,4.48,4.48,0,0,0-2.78-3l-6.39-3-6.15,13.23,6,2.77A10.73,10.73,0,0,0,157.64,177.33Zm-.2-13.17,2.88,1.34a5.48,5.48,0,0,1,1.47.93,1.3,1.3,0,0,1,.14,1.55,1.4,1.4,0,0,1-1.08.92,2.94,2.94,0,0,1-1.55-.33l-3.21-1.49Zm-4,8.64,1.64-3.53,3.25,1.51a3.57,3.57,0,0,1,1.22.84,1.57,1.57,0,0,1,.19,1.81,1.86,1.86,0,0,1-1.64,1.25,3.5,3.5,0,0,1-1.45-.39Z"
        style={{
          fill: "#fff",
        }}
      />
      <path
        d="M163.22,179.08a5.84,5.84,0,0,0,2.89,2.8,5.22,5.22,0,0,0,4.34.29,3.55,3.55,0,0,0,1.77-1.33l-2.61-1.21a2.54,2.54,0,0,1-.84.42,2.39,2.39,0,0,1-1.63-.21,2.82,2.82,0,0,1-1.24-1,2.58,2.58,0,0,1-.06-2.54l7.12,3.31a13.41,13.41,0,0,0,.82-2,5.29,5.29,0,0,0,.16-2.39,4.41,4.41,0,0,0-1-2.23,6,6,0,0,0-2.09-1.52,5.15,5.15,0,0,0-4.12-.27,5.77,5.77,0,0,0-3.16,3.27A5.24,5.24,0,0,0,163.22,179.08Zm4.85-5.66a2.26,2.26,0,0,1,1.78.15,2.54,2.54,0,0,1,1.28,1.24,2.36,2.36,0,0,1,0,1.86l-4.41-2A3,3,0,0,1,168.07,173.42Z"
        style={{
          fill: "#fff",
        }}
      />
      <rect
        x={170.75}
        y={166.46}
        width={1.47}
        height={6.34}
        transform="translate(-54.61 253.67) rotate(-65.08)"
        style={{
          fill: "#fff",
        }}
      />
      <path
        d="M359.8,128.79h0a16.41,16.41,0,0,1-16.41-16.4h0A16.41,16.41,0,0,1,359.8,96h0a16.41,16.41,0,0,1,16.4,16.41h0A16.4,16.4,0,0,1,359.8,128.79Z"
        fill={theme.imageHighlight}
      />
      <path
        d="M351.06,117.88a10.2,10.2,0,0,0,15.69-9.06,7.16,7.16,0,0,0,1.79-1.85,7.57,7.57,0,0,1-2.06.56,3.56,3.56,0,0,0,1.57-2,7.18,7.18,0,0,1-2.27.87,3.59,3.59,0,0,0-6.12,3.27,10.18,10.18,0,0,1-7.39-3.75,3.59,3.59,0,0,0,1.11,4.79,3.54,3.54,0,0,1-1.62-.45,3.58,3.58,0,0,0,2.87,3.56,3.52,3.52,0,0,1-1.62.06,3.58,3.58,0,0,0,3.35,2.49A7.17,7.17,0,0,1,351.06,117.88Z"
        style={{
          fill: "#fff",
        }}
      />
      <path
        d="M209.33,93.79h0a18,18,0,0,1-18-18h0a18,18,0,0,1,18-18h0a18,18,0,0,1,18,18h0A18,18,0,0,1,209.33,93.79Z"
        fill={theme.imageHighlight}
      />
      <path
        d="M203.56,77.43a.43.43,0,0,0,.62-.31c0-.21.19-.76.25-1a.59.59,0,0,0-.18-.68,3.54,3.54,0,0,1-.81-2.42,5.82,5.82,0,0,1,6.06-5.89c3.3,0,5.12,2,5.12,4.72,0,3.55-1.57,6.54-3.91,6.54A1.9,1.9,0,0,1,208.77,76c.37-1.56,1.09-3.24,1.09-4.37a1.65,1.65,0,0,0-1.66-1.85c-1.32,0-2.37,1.37-2.37,3.19a4.79,4.79,0,0,0,.39,2s-1.35,5.7-1.58,6.7a13.7,13.7,0,0,0,0,4.68.16.16,0,0,0,.29.07,13.07,13.07,0,0,0,2.22-4c.15-.54.87-3.38.87-3.38a3.52,3.52,0,0,0,3,1.53c4,0,6.64-3.6,6.64-8.43,0-3.65-3.09-7-7.79-7C204,65,201,69.23,201,72.73,201,74.85,201.84,76.73,203.56,77.43Z"
        style={{
          fill: "#fff",
        }}
      />
      <path
        d="M307.92,163.93h0a11.59,11.59,0,0,1-11.6-11.59h0a11.6,11.6,0,0,1,11.6-11.6h0a11.6,11.6,0,0,1,11.6,11.6h0A11.6,11.6,0,0,1,307.92,163.93Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M307.92,147.12c1.7,0,1.9,0,2.57,0a3.51,3.51,0,0,1,1.18.22,2,2,0,0,1,.73.48,1.88,1.88,0,0,1,.47.73,3.22,3.22,0,0,1,.22,1.18c0,.67,0,.87,0,2.57s0,1.9,0,2.57a3.27,3.27,0,0,1-.22,1.18,2.05,2.05,0,0,1-1.2,1.2,3.51,3.51,0,0,1-1.18.22c-.67,0-.87,0-2.57,0s-1.9,0-2.57,0a3.45,3.45,0,0,1-1.18-.22,1.88,1.88,0,0,1-.73-.47,2,2,0,0,1-.48-.73,3.51,3.51,0,0,1-.22-1.18c0-.67,0-.88,0-2.57s0-1.9,0-2.57a3.45,3.45,0,0,1,.22-1.18,2.16,2.16,0,0,1,1.21-1.21,3.45,3.45,0,0,1,1.18-.22c.67,0,.87,0,2.57,0m0-1.14c-1.73,0-1.95,0-2.62,0a4.91,4.91,0,0,0-1.55.29,3,3,0,0,0-1.12.74,3.08,3.08,0,0,0-.74,1.12,4.91,4.91,0,0,0-.29,1.55c0,.67,0,.89,0,2.62s0,1.94,0,2.62a4.78,4.78,0,0,0,.29,1.54,3.12,3.12,0,0,0,.74,1.13,3.05,3.05,0,0,0,1.12.73,4.62,4.62,0,0,0,1.55.3c.67,0,.89,0,2.62,0s1.94,0,2.62,0a4.5,4.5,0,0,0,1.54-.3,3.2,3.2,0,0,0,1.86-1.86,4.5,4.5,0,0,0,.3-1.54c0-.68,0-.9,0-2.62s0-2,0-2.62a4.62,4.62,0,0,0-.3-1.55,3.05,3.05,0,0,0-.73-1.12,3,3,0,0,0-1.13-.74,4.78,4.78,0,0,0-1.54-.29c-.68,0-.9,0-2.62,0"
        style={{
          fill: "#fff",
        }}
      />
      <path
        d="M307.92,149.07a3.27,3.27,0,1,0,3.26,3.27,3.26,3.26,0,0,0-3.26-3.27m0,5.39a2.12,2.12,0,1,1,2.12-2.12,2.12,2.12,0,0,1-2.12,2.12"
        style={{
          fill: "#fff",
        }}
      />
      <path
        d="M312.08,148.94a.78.78,0,0,1-.77.77.77.77,0,0,1-.76-.77.76.76,0,0,1,.76-.76.77.77,0,0,1,.77.76"
        style={{
          fill: "#fff",
        }}
      />
      <path
        d="M180.43,133.7h0A9.73,9.73,0,0,1,170.7,124h0a9.73,9.73,0,0,1,9.73-9.72h0a9.72,9.72,0,0,1,9.72,9.72h0A9.73,9.73,0,0,1,180.43,133.7Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M178.94,129.85h2.37v-5.93H183l.18-2h-1.83v-1.13c0-.47.1-.65.55-.65h1.28V118.1H181.5c-1.76,0-2.56.77-2.56,2.26v1.58h-1.23v2h1.23Z"
        style={{
          fill: "#fff",
        }}
      />
      <polygon
        points="327.89 83.89 328.8 85.56 330.46 86.47 328.8 87.37 327.89 89.03 326.99 87.37 325.32 86.47 326.99 85.56 327.89 83.89"
        fill={theme.imageHighlight}
      />
      <polygon
        points="286.77 176.04 287.68 177.71 289.34 178.62 287.68 179.52 286.77 181.19 285.86 179.52 284.2 178.62 285.86 177.71 286.77 176.04"
        fill={theme.imageHighlight}
      />
      <polygon
        points="149.69 127.34 151.04 129.8 153.49 131.14 151.04 132.48 149.69 134.94 148.35 132.48 145.9 131.14 148.35 129.8 149.69 127.34"
        fill={theme.imageHighlight}
      />
      <polygon
        points="265.06 46.46 266.4 48.91 268.86 50.26 266.4 51.6 265.06 54.05 263.72 51.6 261.26 50.26 263.72 48.91 265.06 46.46"
        fill={theme.imageHighlight}
      />
      <polygon
        points="337.81 151.12 339.91 154.95 343.73 157.04 339.91 159.14 337.81 162.97 335.72 159.14 331.89 157.04 335.72 154.95 337.81 151.12"
        fill={theme.imageHighlight}
      />
    </g>
    <g id="freepik--Character--inject-192">
      <path
        d="M229.7,228.21c15-19.69,30.71-16.91,41.65-12.15a30.08,30.08,0,0,1,17.56,28.65c-.2,3.14-.87,6.45.41,9.33,2.06,4.63,8,5.94,11.51,9.63,4.74,5.06,3.69,13.06,2.09,19.8s-3.29,14.44.68,20.12c3.63,5.2,10.55,6.6,16.26,9.37a29.8,29.8,0,0,1,15.79,18.59,25.46,25.46,0,0,1-5.4,23.49c-5.55,6-13.89,8.72-22,9.92a81.05,81.05,0,0,1-92.76-84.3"
        fill={theme.text}
      />
      <path
        d="M321.71,357.06c0-.05.51-.49,1.35-1.52a13.75,13.75,0,0,0,2.66-5.09,18.84,18.84,0,0,0,.08-9.05,22.06,22.06,0,0,0-5.55-10.57,26.81,26.81,0,0,0-5.41-4.46A44.44,44.44,0,0,0,308,323a50.87,50.87,0,0,1-7.54-3.57,23.48,23.48,0,0,1-6.51-6.05,31.09,31.09,0,0,1-5.78-17.92,47.91,47.91,0,0,1,.85-10c.61-3.34,1.46-6.66,2.1-10.05a37.53,37.53,0,0,0,.83-7.14,19.56,19.56,0,0,0-1.57-6.78c-.87-2.17-1.89-4.28-2.71-6.48a31.4,31.4,0,0,1-1.41-6.77c-.27-2.26-.27-4.49-.52-6.6a38,38,0,0,0-1.21-6.2,32.63,32.63,0,0,0-5-10.69l0,0h0a22.16,22.16,0,0,0-15.44-10,21.16,21.16,0,0,0-14,2.93,22.59,22.59,0,0,0-6.87,6.38c-1.25,1.8-1.71,2.88-1.77,2.85a14.21,14.21,0,0,1,1.56-3,21.91,21.91,0,0,1,6.83-6.65,21.57,21.57,0,0,1,14.38-3.2,22.89,22.89,0,0,1,16.06,10.19l0,0a33.4,33.4,0,0,1,5.23,11,39.41,39.41,0,0,1,1.26,6.33c.27,2.2.27,4.41.55,6.6a29.94,29.94,0,0,0,1.37,6.55c.8,2.13,1.82,4.23,2.71,6.45a20.71,20.71,0,0,1,1.65,7.11,39.43,39.43,0,0,1-.84,7.36c-.66,3.42-1.51,6.74-2.11,10a46.82,46.82,0,0,0-.85,9.81,30.24,30.24,0,0,0,5.54,17.4,22.91,22.91,0,0,0,6.24,5.85,51,51,0,0,0,7.39,3.55,44,44,0,0,1,7,3.44,27.14,27.14,0,0,1,5.52,4.64,22.5,22.5,0,0,1,5.58,10.92,19,19,0,0,1-.25,9.28,13.35,13.35,0,0,1-2.88,5.11A8.72,8.72,0,0,1,321.71,357.06Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M320.79,375.51c-4.72-27.2-13.23-40.53-16.16-43.74-10.22-11.19-42.5-9.51-42.5-9.51l-45.08,5.49s-32.87,3.41-41.92,29.73l-7,31.31,36.18,1.44.71,6c.88,3.21,2,7,3.2,10.12,2,5.18,6.82,16.12,4,21.19C205,440.31,198,470.67,198,470.67h0l103.69-1.35-12.36-75.47,31.48-18.34"
        fill={theme.imageHighlight}
      />
      <path
        d="M220.68,236a6.63,6.63,0,0,0-5.5,7.11h0l7.1,91.07c.83,10.58,10.57,18.29,21.89,17.32h0c11.42-1,20.15-10.44,19.49-21.13-.69-11.23-1.21-23.06-1.21-23.06s14.3-3.33,16.08-22.39c.88-9.47-.58-24.81-2.18-37.33a20,20,0,0,0-23.17-17.16Z"
        style={{
          fill: "#b78876",
        }}
      />
      <path
        d="M270.07,258.28a2.44,2.44,0,0,1-2.18,2.59,2.31,2.31,0,0,1-2.63-2,2.41,2.41,0,0,1,2.17-2.59A2.32,2.32,0,0,1,270.07,258.28Z"
        fill={theme.text}
      />
      <path
        d="M273.53,255.81c-.28.34-2.2-.9-4.81-.72s-4.42,1.6-4.73,1.29c-.14-.13.12-.72.92-1.38a6.71,6.71,0,0,1,3.76-1.43,6.45,6.45,0,0,1,3.85,1C273.36,255.11,273.66,255.66,273.53,255.81Z"
        fill={theme.text}
      />
      <path
        d="M244.49,260.6a2.42,2.42,0,0,1-2.18,2.59,2.31,2.31,0,0,1-2.63-2,2.43,2.43,0,0,1,2.17-2.59A2.32,2.32,0,0,1,244.49,260.6Z"
        fill={theme.text}
      />
      <path
        d="M248,258c-.28.34-2.2-.9-4.8-.73s-4.43,1.6-4.73,1.3c-.15-.13.11-.72.91-1.38a6.71,6.71,0,0,1,3.76-1.43,6.44,6.44,0,0,1,3.85,1C247.8,257.25,248.11,257.8,248,258Z"
        fill={theme.text}
      />
      <path
        d="M258.66,276.65c0-.15,1.58-.53,4.18-1,.66-.11,1.28-.28,1.36-.74a3.33,3.33,0,0,0-.57-1.95c-.73-1.56-1.49-3.21-2.29-4.93-3.19-7-5.55-12.83-5.27-13s3.11,5.47,6.3,12.5c.77,1.74,1.51,3.39,2.21,5a3.85,3.85,0,0,1,.52,2.58,1.69,1.69,0,0,1-1,1,4.38,4.38,0,0,1-1.12.23C260.32,276.68,258.68,276.79,258.66,276.65Z"
        fill={theme.text}
      />
      <path
        d="M262.45,307.33a48.1,48.1,0,0,1-25.7-5.1s7,12.56,25.73,9.57Z"
        style={{
          fill: "#aa6550",
        }}
      />
      <path
        d="M248,247.71c-.21.72-2.83.55-5.86,1.12s-5.45,1.56-5.89.95c-.2-.3.18-1,1.14-1.74a10.39,10.39,0,0,1,8.95-1.58C247.47,246.84,248.07,247.36,248,247.71Z"
        fill={theme.text}
      />
      <path
        d="M272.08,248.34c-.42.62-2.25.12-4.41.24s-4,.65-4.42.06c-.2-.29.05-.9.81-1.51a6.1,6.1,0,0,1,3.52-1.2,6,6,0,0,1,3.59,1C272,247.45,272.27,248,272.08,248.34Z"
        fill={theme.text}
      />
      <path
        d="M255.13,279.12a7.91,7.91,0,0,1,4.78,1.67,3,3,0,0,1,1.23,1.22,2.54,2.54,0,0,1-.26,2.26,4.56,4.56,0,0,1-4.31,2.31,4.2,4.2,0,0,1-3.62-3.21,3.88,3.88,0,0,1,2.18-4.25"
        style={{
          fill: "#aa6550",
        }}
      />
      <path
        d="M261.53,284.22c0,.2-.65.5-1.78.43a9.73,9.73,0,0,1-4.08-1.33,11.18,11.18,0,0,1-3.26-2.74c-.68-.87-.89-1.56-.72-1.67.35-.22,2.06,1.57,4.75,3a20.76,20.76,0,0,0,3.51,1.61C260.88,283.89,261.51,284,261.53,284.22Z"
        fill={theme.text}
      />
      <path
        d="M223.15,326.66c13-4.58,14.32-33.16,5.46-46.83a21.87,21.87,0,0,0,2.95-24.56,18.13,18.13,0,0,0,11.34-25.56s-7.57-4.31-14.75-2.35-12.31,7.54-15.64,21-.23,25.22-5.84,33.65-12.62,14.71-11.78,23.63,6.84,27.22,6.84,27.22Z"
        fill={theme.text}
      />
      <path
        d="M196.51,314.33a18.12,18.12,0,0,1-.71-3.81,25.43,25.43,0,0,1,0-4.56,25.5,25.5,0,0,1,10.5-18.43c2.32-1.8,4.93-3.57,6.72-6.19a15.14,15.14,0,0,0,1.93-4.38,25.7,25.7,0,0,0,.72-4.93c.2-3.38,0-6.71.29-9.94a24.28,24.28,0,0,1,.78-4.7,16.25,16.25,0,0,1,.78-2.19,12.81,12.81,0,0,1,1.06-2,26.45,26.45,0,0,1,5.82-6.08c2-1.65,4-3.1,5.63-4.61,3.27-3,5.08-6.28,5.56-8.71a11.06,11.06,0,0,0,.06-3.82s0,.08.07.24l.15.74a9.65,9.65,0,0,1-.09,2.88c-.42,2.5-2.21,5.86-5.49,8.94-1.64,1.54-3.6,3-5.62,4.68a25.69,25.69,0,0,0-5.68,6,11.28,11.28,0,0,0-1,2,15.21,15.21,0,0,0-.75,2.12,24,24,0,0,0-.75,4.61c-.26,3.19-.08,6.52-.28,9.94a26.31,26.31,0,0,1-.74,5,15.52,15.52,0,0,1-2,4.53c-1.87,2.72-4.53,4.49-6.85,6.28a25.51,25.51,0,0,0-5.85,5.84,25.8,25.8,0,0,0-3.31,6.41,27.14,27.14,0,0,0-1.34,5.82,26,26,0,0,0-.08,4.52,23.58,23.58,0,0,0,.35,2.84c.06.3.1.54.13.74A.79.79,0,0,1,196.51,314.33Z"
        fill={theme.compImgHighlight}
      />
      <g
        style={{
          opacity: 0.2,
        }}
      >
        <path d="M282.66,443.62c-4.31,1.38-9.21,0-12.71-2.84A22.12,22.12,0,0,1,263,429.35a55.86,55.86,0,0,1-1.55-13.47c-.34-13.67.46-27.34,1.37-41Z" />
      </g>
      <path
        d="M214.33,422.41a12.67,12.67,0,0,1-.76-1.57c-.46-1-1.11-2.5-1.88-4.34a114.14,114.14,0,0,1-5.18-14.75,56.68,56.68,0,0,1-2-15.5,36.53,36.53,0,0,1,.38-4.73c.07-.56.16-1,.22-1.27a2.41,2.41,0,0,1,.11-.44,13.54,13.54,0,0,1-.13,1.73c-.11,1.11-.22,2.72-.22,4.71A60.86,60.86,0,0,0,207,401.61a135.71,135.71,0,0,0,5,14.75c.7,1.8,1.29,3.28,1.73,4.41A9.62,9.62,0,0,1,214.33,422.41Z"
        fill={theme.text}
      />
      <path
        d="M259.52,378.09a5.27,5.27,0,0,1-1,1,7.3,7.3,0,0,1-1.42.9,4.06,4.06,0,0,1-2.21.41,2.8,2.8,0,0,1-2.28-1.49,15.75,15.75,0,0,1-.83-3c-.48-2.1-1-4.39-1.54-6.8-1.08-4.83-2-9.21-2.69-12.38-.3-1.52-.56-2.78-.75-3.77a6.67,6.67,0,0,1-.21-1.39,7.19,7.19,0,0,1,.4,1.35l.92,3.73c.75,3.15,1.76,7.52,2.84,12.35.53,2.41,1,4.7,1.5,6.81a17,17,0,0,0,.74,2.88,2.41,2.41,0,0,0,2,1.32,5,5,0,0,0,3.46-1.1A9.3,9.3,0,0,1,259.52,378.09Z"
        fill={theme.text}
      />
      <path
        d="M252.37,354.29s.16-.16.56-.24a2.52,2.52,0,0,1,1.65.31,2.78,2.78,0,0,1,1.45,2.05,2.75,2.75,0,0,1-4.62,2.1,2.82,2.82,0,0,1-.6-2.43,2.56,2.56,0,0,1,.86-1.46c.32-.24.54-.28.55-.26s-.17.14-.42.41a2.54,2.54,0,0,0-.62,1.37,2.47,2.47,0,0,0,.58,2,2.31,2.31,0,0,0,3.79-1.73,2.5,2.5,0,0,0-1.15-1.78,2.6,2.6,0,0,0-1.45-.42C252.58,354.26,252.38,354.34,252.37,354.29Z"
        fill={theme.text}
      />
      <path
        d="M256,366.57s.17-.17.57-.25a2.52,2.52,0,0,1,1.65.31,2.8,2.8,0,0,1,1.45,2.05,2.76,2.76,0,0,1-4.62,2.11,2.84,2.84,0,0,1-.6-2.44,2.5,2.5,0,0,1,.86-1.45c.31-.25.54-.29.55-.27s-.17.15-.42.42a2.64,2.64,0,0,0,0,3.41,2.31,2.31,0,0,0,3.79-1.73,2.46,2.46,0,0,0-1.16-1.78,2.57,2.57,0,0,0-1.44-.43C256.26,366.53,256.06,366.61,256,366.57Z"
        fill={theme.text}
      />
      <path
        d="M315.58,354.08c0,.14-31.68,3.11-70.77,6.64S174,367,174,366.84s31.67-3.12,70.78-6.64S315.57,353.94,315.58,354.08Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M316.75,359c0,.14-32.41,3.18-72.4,6.78s-72.44,6.41-72.45,6.27,32.4-3.18,72.4-6.79S316.73,358.86,316.75,359Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M201.62,333.81a8.66,8.66,0,0,1,.49,1.54c.29,1,.65,2.45,1,4.25a111.3,111.3,0,0,1,2.19,14.31,110,110,0,0,1,.31,14.46c-.08,1.85-.19,3.35-.3,4.38a9,9,0,0,1-.22,1.59,9.77,9.77,0,0,1,0-1.6c0-1,.1-2.53.13-4.38a137.76,137.76,0,0,0-.46-14.41,135,135,0,0,0-2-14.27c-.35-1.81-.66-3.28-.89-4.28A10.13,10.13,0,0,1,201.62,333.81Z"
        fill={theme.text}
      />
      <path
        d="M239.54,320.58s17.34-12.55,18-12.2,9.29,2.28,9.29,2.28l1.41-7.54s-2.46-14,0-15.26,3,0,3,1.23,2.8,11.22,2.8,11.22L275.12,314l3.68,3.33v27l-16.93,4.61-4.12-8.29-.7-5.09s-3.16,1.23-3.68.53-1.05-4-1.05-4l-.71,4.73s-4.73,1.41-5.26.53,1.58-12.45,1.58-12.45l5.61-7.72s-6.89,4.2-8.22,4.69C242.39,322.92,239.54,320.58,239.54,320.58Z"
        style={{
          fill: "#b78876",
        }}
      />
      <path
        d="M261.34,348.35c0,1,2.62,56,3.22,60s.94,41.24,22.37,44.1c0,0,10.73-.13,11.74-1l0,0a49.37,49.37,0,0,0,19.85-36.64l2.23-39.26s-12.3,1.59-28.25,3v10.31s-3.71-10.38-4.31-13.28-9.43-31.18-9.43-31.18Z"
        style={{
          fill: "#b78876",
        }}
      />
      <path
        d="M275.12,314a5,5,0,0,1-.16-1l-.31-2.9c-.24-2.56-.58-6.1-1-10.28v0c-.7-3.62-1.52-7.79-2.39-12.23l0-.18.22.21-1.67-.24.16,0a5.74,5.74,0,0,0-2.68,3.86,11.72,11.72,0,0,0,0,4.57c.23,1.46.56,2.84.76,4.16a19,19,0,0,1,.21,3.69,18.14,18.14,0,0,1-1,5.22c-.21.59-.39,1-.53,1.33s-.22.45-.24.44.23-.64.58-1.83a19.79,19.79,0,0,0,.8-5.17,19.5,19.5,0,0,0-.28-3.62c-.21-1.29-.55-2.66-.8-4.15a12,12,0,0,1,0-4.75,6.26,6.26,0,0,1,2.92-4.21l.08,0h.08l1.67.23.19,0,0,.18,0,.18c.85,4.44,1.64,8.62,2.34,12.24v0h0c.32,4.19.58,7.73.78,10.3q.1,1.8.18,2.91A7.3,7.3,0,0,1,275.12,314Z"
        style={{
          fill: "#aa6550",
        }}
      />
      <path
        d="M253.54,317.15a5.47,5.47,0,0,1-.94.64c-.63.39-1.56,1-2.74,1.65s-2.6,1.52-4.28,2.4a5.32,5.32,0,0,1-1.39.57,3.15,3.15,0,0,1-1.61-.09,6.55,6.55,0,0,1-2.8-1.9l-.18-.19.23-.16,8.32-5.64,9.37-6.29.09-.06.1,0,10,2.51,2.82.75a6.63,6.63,0,0,1,1,.31,5.39,5.39,0,0,1-1-.17l-2.85-.62-10-2.33.18,0-9.34,6.33-8.34,5.61.05-.36a6.05,6.05,0,0,0,2.56,1.78,2.69,2.69,0,0,0,1.4.1,5,5,0,0,0,1.29-.51c1.68-.84,3.12-1.64,4.32-2.29l2.8-1.53A7.42,7.42,0,0,1,253.54,317.15Z"
        style={{
          fill: "#aa6550",
        }}
      />
      <path
        d="M252.87,328a2,2,0,0,1,0,.54c0,.41-.1.92-.16,1.53-.18,1.41-.42,3.31-.72,5.61v.05l0,0a4.09,4.09,0,0,1-2.53,1.57,4.73,4.73,0,0,1-3.26-.77l-.13-.08,0-.16c.47-2.78,1-5.86,1.53-9.09.18-1,.35-2,.51-3v-.05l0,0a26.43,26.43,0,0,1,2.37-2.83c.8-.87,1.59-1.69,2.34-2.47,1.52-1.56,2.91-3,4.14-4.17l0,0H257a23.48,23.48,0,0,1,2.91-.77,2.46,2.46,0,0,1,1.26.16,10.25,10.25,0,0,1,1,.41,12.76,12.76,0,0,0,1.3.57,3.07,3.07,0,0,1,.47.17,4.54,4.54,0,0,1-1.85-.55c-.29-.12-.6-.25-.95-.36a2.33,2.33,0,0,0-1.15-.11c-.85.14-1.77.53-2.86.84l.09,0c-1.2,1.25-2.56,2.68-4.06,4.23l-2.31,2.48a28.77,28.77,0,0,0-2.29,2.75l0-.08c-.16,1-.33,2-.5,3-.56,3.23-1.1,6.31-1.58,9.09l-.1-.23a4.34,4.34,0,0,0,2.93.73,3.72,3.72,0,0,0,2.29-1.38l0,.09c.36-2.28.66-4.17.88-5.58l.27-1.52A2.18,2.18,0,0,1,252.87,328Z"
        style={{
          fill: "#aa6550",
        }}
      />
      <path
        d="M265.6,327.94a12.15,12.15,0,0,1-1.72.16l-4.71.24.16-.09a8.74,8.74,0,0,1-2.48,2.58l.1-.19a14.94,14.94,0,0,1-.5,4,4.26,4.26,0,0,1-.45,1,2.11,2.11,0,0,1-1,.76,4.07,4.07,0,0,1-2.37.1l-.19,0v-.21c0-1,0-2.06,0-3.14,0-1.95,0-3.83,0-5.61v-.09l.05-.07,4.58-5.92.06-.07h.1l6.07-.22,1.67,0c.39,0,.59,0,.59,0a2.3,2.3,0,0,1-.58.09l-1.67.14-6.06.4.15-.08-4.51,6,.06-.15v8.75l-.19-.25a3.56,3.56,0,0,0,2-.07,1.56,1.56,0,0,0,.74-.57,3.88,3.88,0,0,0,.39-.9,15,15,0,0,0,.54-3.83v-.12l.1-.06a8.51,8.51,0,0,0,2.39-2.4l.05-.09h.1l4.72-.08A10.5,10.5,0,0,1,265.6,327.94Z"
        style={{
          fill: "#aa6550",
        }}
      />
      <path
        d="M261.87,348.35a7.46,7.46,0,0,1-1.51-1.82,21.56,21.56,0,0,1-3.65-10.7,7.1,7.1,0,0,1,.09-2.36,29.39,29.39,0,0,0,5.07,14.88Z"
        style={{
          fill: "#aa6550",
        }}
      />
      <path
        d="M264.64,335.48a6.49,6.49,0,0,0-6.61-2.2c0-.06.34-.31,1-.48a5,5,0,0,1,2.76.12,5.1,5.1,0,0,1,2.28,1.55C264.55,335,264.7,335.45,264.64,335.48Z"
        style={{
          fill: "#aa6550",
        }}
      />
      <path
        d="M265,328.53a11.13,11.13,0,0,1-.06,3.32,10.87,10.87,0,0,1-.58,3.25,10.36,10.36,0,0,1,.06-3.32A10.6,10.6,0,0,1,265,328.53Z"
        style={{
          fill: "#aa6550",
        }}
      />
      <path
        d="M302.91,433.25a11.15,11.15,0,0,0,1.61-3.26,12.67,12.67,0,0,0,.45-4.23,20.15,20.15,0,0,0-1.18-5.53c-.68-2-1.64-4.11-2.54-6.43s-1.87-4.81-2.86-7.43c-1.92-5.27-3.93-11.09-6-17.23-4.05-12.29-7.47-23.49-9.88-31.61-1.21-4.06-2.16-7.36-2.8-9.64-.31-1.11-.55-2-.72-2.63-.08-.28-.13-.5-.18-.69a.61.61,0,0,1,0-.24.92.92,0,0,1,.09.23l.23.67.81,2.61c.72,2.3,1.72,5.57,3,9.58,2.5,8.1,6,19.28,10,31.56,2,6.13,4,11.95,5.92,17.22,1,2.62,1.88,5.13,2.81,7.44s1.82,4.45,2.49,6.47a20.64,20.64,0,0,1,1.13,5.64,12.82,12.82,0,0,1-.56,4.3,8.6,8.6,0,0,1-1.2,2.46A4.14,4.14,0,0,1,302.91,433.25Z"
        style={{
          fill: "#aa6550",
        }}
      />
      <path
        d="M262.75,445.94,196,436l8.31-45.75L169,388.79l-8.92,50.39A27.6,27.6,0,0,0,187,472l77.83-.86Z"
        style={{
          fill: "#b78876",
        }}
      />
      <path
        d="M257.93,447.08c.66.22,15.31-6.77,15.31-6.77L299,441.62s-.65,4.38-2.62,5.47-14,0-14,0l6.12,4.37,10.49-.88,2.63-2.19s.27,7.24-1.7,8.55-7.62,1.78-7.62,1.78a18.92,18.92,0,0,1-.45,3.31c-.35,1.14-3.42,2.28-3.42,2.28a41.13,41.13,0,0,1-2.74,4.9c-.36.4-3.14,1.27-6.11,2.1A26.24,26.24,0,0,1,265,471.2l-7.07-2.11V447.55"
        style={{
          fill: "#b78876",
        }}
      />
      <path
        d="M302.1,448.51s-.1.1-.32.26a9.43,9.43,0,0,1-1,.63,14.73,14.73,0,0,1-4.14,1.61,16.27,16.27,0,0,1-6.79.09,15.26,15.26,0,0,1-3.94-1.36c-1.32-.64-2.52-1.6-3.95-2.13l-1.15-.42,1.22-.05a47.46,47.46,0,0,1,6,.41,15.69,15.69,0,0,0,6.24-.37c2.42-.72,4.46-2.82,4.55-5.16l.25.26-18.67-1.09-5.46-.37-1.46-.12a1.85,1.85,0,0,1-.51-.07,2.91,2.91,0,0,1,.51,0l1.47,0,5.47.22,18.67.9.25,0V442a5.64,5.64,0,0,1-1.53,3.52,7.61,7.61,0,0,1-3.38,2.12,16.19,16.19,0,0,1-6.43.38,47.84,47.84,0,0,0-5.92-.43l.08-.47a42.07,42.07,0,0,1,4,2.18,15,15,0,0,0,3.81,1.36,16.22,16.22,0,0,0,10.77-1.43C301.62,448.8,302.08,448.48,302.1,448.51Z"
        style={{
          fill: "#aa6550",
        }}
      />
      <path
        d="M296.55,458.16a27.26,27.26,0,0,1-5.92,1.07,26.16,26.16,0,0,1-6,.23,50.4,50.4,0,0,1,6-.74A49,49,0,0,1,296.55,458.16Z"
        style={{
          fill: "#aa6550",
        }}
      />
      <path
        d="M290.87,463.13a12,12,0,0,1-3.19,1.52,11.76,11.76,0,0,1-3.37,1,12,12,0,0,1,3.18-1.51A12.52,12.52,0,0,1,290.87,463.13Z"
        style={{
          fill: "#aa6550",
        }}
      />
      <g
        style={{
          opacity: 0.2,
        }}
      >
        <path d="M255.18,370.37a2.34,2.34,0,1,0,4.48-.71,2.68,2.68,0,0,1-4.91.23" />
      </g>
      <g
        style={{
          opacity: 0.2,
        }}
      >
        <path d="M251.68,358.19a2.34,2.34,0,1,0,4.48-.71,2.68,2.68,0,0,1-4.9.23" />
      </g>
      <g
        style={{
          opacity: 0.2,
        }}
      >
        <path d="M205.87,380.56c1.23,9.19,6.61,17.64,6.58,26.91,0,.92-.2,2-1.06,2.35-1.1.41-2-.85-2.52-1.92a49.61,49.61,0,0,1-3.67-27.21" />
      </g>
      <path
        d="M291,346.31a8.33,8.33,0,0,1,.26,1.56c.13,1,.3,2.45.47,4.25.35,3.6.71,8.59.88,14.11s.11,10.52,0,14.13c-.06,1.81-.14,3.27-.21,4.28a10,10,0,0,1-.16,1.56,8.36,8.36,0,0,1,0-1.57c0-1.1,0-2.54,0-4.28,0-3.61,0-8.6-.13-14.11s-.47-10.48-.73-14.09c-.12-1.73-.22-3.16-.3-4.26A10.42,10.42,0,0,1,291,346.31Z"
        fill={theme.text}
      />
    </g>
  </svg>
    );
  }
}